/* tslint:disable */
/* eslint-disable */
export enum NotificationSourceType {
    Events = 1,
    EventSettings = 2,
    Statistics = 3,
    Users = 4,
    All = 5
}